import React from 'react';
import { FiltersProvider } from '../../../../../components/providers/FiltersProvider';
import InvoiceProfileLayout from '../../InvoiceProfileLayout';
import InvoiceActivityHistory from './InvoiceActivityHistory';

interface InvoiceActivityHistoryWrapperProps { }

const InvoiceActivityHistoryWrapper: React.FC<InvoiceActivityHistoryWrapperProps> = () => {

    return (
        <FiltersProvider>
            <InvoiceProfileLayout>
                <InvoiceActivityHistory />
            </InvoiceProfileLayout>
        </FiltersProvider>
    );
};

export default InvoiceActivityHistoryWrapper;